import { IS_AUTO_TEST_HIDE } from 'reactApp/appHelpers/configHelpers';
import { vigboTariffModalRemindDays, vigboTariffs } from 'reactApp/appHelpers/featuresHelpers/features/vigbo';
import { handleBillingDataSuccess } from 'reactApp/modules/billingData/billingData.handler.saga';
import { getLatestExpiredSubscription } from 'reactApp/modules/billingData/billingData.helpers';
import { getBillingDataRequestIfNotLoaded } from 'reactApp/modules/billingData/billingData.module';
import { BillingDataSelectors } from 'reactApp/modules/billingData/billingData.selectors';
import { CardActions } from 'reactApp/modules/creditCard/creditCard.module';
import { handleLoadCardSuccess } from 'reactApp/modules/creditCard/creditCard.saga';
import { CardSelectors } from 'reactApp/modules/creditCard/creditCard.selectors';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { addPromoToShowQueue, promoShown, removePromo } from 'reactApp/modules/promo/promo.module';
import { PromoSelectors } from 'reactApp/modules/promo/promo.selectors';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { snackbarController } from 'reactApp/modules/snackbar/snackbar.controller';
import { SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { SubscriptionRenewalActions } from 'reactApp/modules/subscriptionRenewal/subscriptionRenewal.module';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { store } from 'reactApp/store';
import { VigboWhatsNewPropsBuilder } from 'reactApp/ui/VigboWhatsNew/VigboWhatsNew.builder';
import { closeVigboWhatsNew, renderVigboWhatsNew } from 'reactApp/ui/VigboWhatsNew/VigboWhatsNew.helpers';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';
import { put, select } from 'typed-redux-saga';

const PROMO_ID = 'vigbo-tariff-renew-remind';

export function* initVigboRenewRemind() {
    const storage = yield* select(getCurrentStorage);
    const { isHome, isVigbo } = getStorage(storage);
    const isMobile = yield* select(EnvironmentSelectors.isMobile);
    const isPaid = yield* select(UserSelectors.isPaidUser);
    const isCorpUser = yield* select(UserSelectors.isCorpUser);
    const isBizUser = yield* select(UserSelectors.isBizUser);
    const isSocialUser = yield* select(UserSelectors.isSocialUser);

    // показываем на /home и на /vigbo
    // скрываем на автотестых и таче
    // исключаем бесплатников, корпов, бизов и соцников
    if (!(isHome || isVigbo) || IS_AUTO_TEST_HIDE || isMobile || !isPaid || isCorpUser || isBizUser || isSocialUser) {
        return;
    }

    yield* put(getBillingDataRequestIfNotLoaded());
    const billingDataSuccess = yield* handleBillingDataSuccess();
    if (!billingDataSuccess) {
        return;
    }

    const vigboSubs = yield* select(BillingDataSelectors.getSubscriptionsByProductIds, vigboTariffs);
    const vigboSubsWithoutRenew = vigboSubs.filter((tariff) => !tariff.autorenewal);
    const latestExpireTariff = getLatestExpiredSubscription(vigboSubsWithoutRenew);
    if (!latestExpireTariff) {
        return;
    }

    const diffInMs = latestExpireTariff.expires - Date.now();
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    /** Если не день напоминания или в этот день уже показывали промку */
    if (!vigboTariffModalRemindDays.includes(diffInDays) || storeHelper.getValue(PROMO_ID + diffInDays.toString())) {
        return;
    }

    yield* put(CardActions.loadCardIfNotLoaded());
    const cardSuccess = yield* handleLoadCardSuccess();
    if (!cardSuccess) {
        return;
    }
    const { card } = yield* select(CardSelectors.getCard);

    const onModalClose = () => {
        store.dispatch(removePromo(EPromoType.vigboRenewRemind));
    };

    yield* put(
        addPromoToShowQueue({
            promoId: PROMO_ID,
            type: EPromoType.vigboRenewRemind,
            expireDate: latestExpireTariff.expires,
            tariffSpace: latestExpireTariff.space,
            onClose: onModalClose,
            onShow: () => {
                storeHelper.markAsShown(PROMO_ID + diffInDays.toString());
                store.dispatch(promoShown(EPromoType.vigboRenewRemind));
                sendPaymentGa({
                    eventCategory: ECategoryGa.vigbo,
                    action: 'show-communication-expired-sub',
                });
            },
            onClick: () => {
                sendPaymentGa({
                    eventCategory: ECategoryGa.vigbo,
                    action: 'click-communication-expired-sub',
                });

                store.dispatch(
                    SubscriptionRenewalActions.addAutoRenew({
                        subscription: latestExpireTariff,
                        card,
                        onSuccess: () => {
                            snackbarController.showSnackbar({
                                id: 'vigbo-enable-renew',
                                closable: true,
                                text: 'Автопродление включено',
                                type: SnackbarTypes.success,
                            });
                            closeVigboWhatsNew();
                            onModalClose();
                        },
                    })
                );
            },
        })
    );
}

export function* showVigboRenewRemind() {
    const promo = yield* select(PromoSelectors.getPromo(EPromoType.vigboRenewRemind));

    if (!promo) {
        return;
    }

    /** Собираем пропсы на основе данных из промо */
    const { expireDate, tariffSpace, onClick, onClose, onShow } = promo;
    const props = VigboWhatsNewPropsBuilder.renewRemind(expireDate, tariffSpace, onClick, onClose, onShow);

    renderVigboWhatsNew(props);
}
